import { call, put, takeLatest } from "redux-saga/effects";
import {
  onGetTranslationClient,
  onGetTranslationClientError,
  onGetTranslationClientSuccess,
} from "../Store/Slices/translationClientSlice";
import { callTranslationGetApi } from "../Context/translationClientApi";

function* GetTranslationClient() {
  try {
    const getTranslationClientResponse = yield call(callTranslationGetApi);
    if (getTranslationClientResponse.httpStatusCode === "200") {
      yield put(
        onGetTranslationClientSuccess({
          getData: getTranslationClientResponse.response,
          message: getTranslationClientResponse.errorMessage,
          status_code: getTranslationClientResponse.httpStatusCode,
        })
      );
    } else {
      yield put(
        onGetTranslationClientError({
          getData: getTranslationClientResponse.response,
          message: getTranslationClientResponse.errorMessage,
          status_code: getTranslationClientResponse.httpStatusCode,
        })
      );
    }
  } catch (error) {
    const message =
      error.response.data.responseMessage || "Something went wrong";
    yield put(
      onGetTranslationClientError({ data: [], message, status_code: 400 })
    );
  }
}
export default function* translationClientSaga() {
  yield takeLatest(onGetTranslationClient.type, GetTranslationClient);
}
